import Sidebar from "./Sidebar"
import SidebarItem from "./SidebarItem"
import SidebarLink from "./SidebarLink"
import SidebarBranding from "./SidebarBranding"

export type { SidebarProps } from "./Sidebar"
export type { SidebarItemProps } from "./SidebarItem"
export type { SidebarLinkProps } from "./SidebarLink"
export type { SidebarBrandingProps } from "./SidebarBranding"

export { default as useSidebarContext } from "./sidebar.context"

export default Object.assign(Sidebar, {
  Item: SidebarItem,
  Link: SidebarLink,
  Branding: SidebarBranding,
})
